export default {
  setIpLoginLoadingState(state, loading) {
    state.ipLoginLoading = loading;
  },
};
